import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, setAuth } from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

function LoginPage({ title, eyebrow, endpoint, redirect, testidPrefix, demoHint }) {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post(endpoint, { email, password });
      setAuth(data.token, data.user);
      toast.success("Welcome back.");
      nav(redirect);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-[#FDFBF7] min-h-screen flex flex-col">
      <Navbar />
      <section className="flex-1 grid md:grid-cols-2">
        <div className="hidden md:block relative overflow-hidden border-r border-[#EBE8DF]">
          <img src="https://images.pexels.com/photos/36356065/pexels-photo-36356065.jpeg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-90"/>
          <div className="absolute inset-0 bg-[#FDFBF7]/40" />
          <div className="absolute inset-0 p-12 flex flex-col justify-end">
            <p className="label-eyebrow">{eyebrow}</p>
            <h1 className="font-display text-5xl mt-4 leading-tight max-w-md">A calm place to track every move on your project.</h1>
          </div>
        </div>
        <div className="flex items-center justify-center px-6 md:px-12 py-20">
          <form onSubmit={submit} className="w-full max-w-sm" data-testid={`${testidPrefix}-form`}>
            <p className="label-eyebrow">{eyebrow}</p>
            <h2 className="font-display text-4xl mt-3 leading-tight">{title}</h2>
            <div className="mt-10 space-y-6">
              <div>
                <label className="label-eyebrow">Email</label>
                <input data-testid={`${testidPrefix}-email`} type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input-line"/>
              </div>
              <div>
                <label className="label-eyebrow">Password</label>
                <input data-testid={`${testidPrefix}-password`} type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="input-line"/>
              </div>
            </div>
            <button data-testid={`${testidPrefix}-submit`} disabled={loading} className="btn-primary mt-10 w-full justify-center">
              {loading ? "Signing in…" : "Sign in"}
            </button>
            <p className="mt-6 text-sm text-[#8B8C89]">{demoHint}</p>
            <p className="mt-2 text-sm"><Link to="/" className="ulink">← Back to site</Link></p>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default function PortalLogin() {
  return (
    <LoginPage
      title="Sign in to your portal."
      eyebrow="Client Portal"
      endpoint="/auth/client/login"
      redirect="/portal"
      testidPrefix="portal-login"
      demoHint="Demo: client@demo.com / client123"
    />
  );
}
export { LoginPage };
